import AgentInterface from "./AgentInterface";
import { BsJournalArrowUp } from "react-icons/bs";

class LRequerimientosAgent extends AgentInterface {
    constructor(config = {}) {
        super({
            name: "Agente de levantamiento de Requerimientos",
            description: "Agente para el levantamiento de requerimientos.",
            icon: BsJournalArrowUp,
            webhookEndpoint: "/webhook/asistente_req_multiagente",
            ...config,
        });

        if (!config.n8nService) {
            throw new Error('n8nService es requerido para LRequerimientosAgent');
        }
        this.n8nService = config.n8nService;
    }

    /**
     * Envía un mensaje al webhook de n8n y devuelve la respuesta
     * @param {string} message - Mensaje del usuario
     * @param {Object} context - Contexto adicional (historial, etc.)
     * @returns {Promise<Object>} Respuesta del agente
     */
    async sendMessage(message, context = {}) {
        try {
            const response = await this.n8nService.sendToWebhook(
                this.config.webhookEndpoint,
                {
                    message,
                    context: {
                        userId: context.userId,
                        sessionId: context.sessionId,
                        // Agregar más contexto según sea necesario
                    },
                }
            );

            return {
                success: true,
                response: response.message || 'No se recibió respuesta del asistente',
                metadata: response.metadata || {},
            };
        } catch (error) {
            console.error('Error en LRequerimientosAgent:', error);
            return {
                success: false,
                error: 'No se pudo conectar con el asistente. Por favor, inténtalo de nuevo más tarde.',
                originalError: error.message,
            };
        }
    }
}

export default LRequerimientosAgent;